





































import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { stringUtil } from "@/models/stringUtil.ts";
import { ElementMenuItem } from "@/models/elementMenuItem.ts";
import {
  PresetMenuItem,
  presets,
  PresetType,
  PresetStep,
} from "@/models/presets";
import { Vector2 } from "@babylonjs/core";
import { ElementType, SpecyficType } from "@/models/element";
import { base64Warehouse } from "@/models/base64warehouse";
import store from "@/store";
import SvgIcon from "@/components/SvgIcon.vue";

@Component({
  components: {
    SvgIcon,
  },
})
export default class AvatarComponent extends Vue {
  @Prop({ type: ElementMenuItem, required: true }) element: ElementMenuItem;

  private readonly avatar: string = this.element.avatar;
  private readonly label: string = this.element.text;
  private readonly tooltip: string[] = this.element.tooltip;
  private readonly offset: number =
    this.$store.getters.configuration.tiny === "true" ? -1 : -1;
  private readonly avatarSize: number =
    this.$store.getters.configuration.tiny === "true" ? 55 : 70;

  private isPopoverOpen = false;
  private openGroup = stringUtil.generateUUID();

  //private readonly tootlipHtml: string = this.getTooltip();

  private getTooltip(): string {
    var r = this.element.tooltip.map((x) => {
      return "<p>" + this.$t(x) + "</p>";
    });
    return r.join("");
  }

  private displayed: boolean = false;

  private click(): void {
    if (this.$store.getters.scene.selectedElementMenuItem === this.element) {
      this.$store.commit("clearSceneState");
    } else {
      this.$store.commit("clearSceneState");
      this.$store.commit("selectElementMenuItem", this.element);
    }
  }

  private getClass(element: ElementMenuItem): string {
    let result: string = "clickable";

    if (this.$store.getters.scene.tasks) result += " disabled";
    if (this.$store.getters.scene.selectedElementMenuItem === element)
      result += " selected";

    return result;
  }

  private get isDisabled(): boolean {
    return (
      this.displayed || !this.element.tooltip || !this.element.tooltip.length
    );
  }

  private onPopupHide(): void {
    this.displayed = true;
  }
}
